export const SHOW_CLEAR = 'show_clear';
export const SHOW_CLEAR_ALL_INSTANCES_FOR_SERIES =
  'show_clear_all_instances_for_series';
export const SHOW_CLEAR_ONE = 'show_clear_one';
export const SHOW_CLEAR_ALL_BUT_PAST_INSTANCES_FOR_SHOW =
  'show_clear_all_but_past_instances_for_show';
export const SHOW_DELETE = 'show_delete';
export const SHOW_ERROR = 'show_error';
export const SHOW_FETCHING = 'show_fetching';
export const SHOW_POSTING = 'show_posting';
export const SHOW_SEARCH = 'show_search';
export const SHOW_UPDATE = 'show_update';
export const SHOW_UPDATE_HOST = 'show_update_host';
export const SHOW_SELECTED = 'show_selected';
export const SHOW_UNSELECTED = 'show_unselected';

export const SHOW_DELETE_SERIES = 'show_delete_series';
